import CreateProfileForm from './CreateProfileForm';

export default CreateProfileForm;


// WEBPACK FOOTER //
// ./src/components/forms/CreateProfileForm/index.js